export const templateSendFeedbackEmailType = document.createElement('template');
import { styles } from './template.scss';

templateSendFeedbackEmailType.innerHTML = `
  <style>${styles}</style>

  <gz-card class="gz-feedback-card" cardwidth="400" >
    <gz-form-field>
        <gz-input gz-form-input="" type="text"></gz-input>
        <gz-text></gz-text>
    </gz-form-field>
    <gz-button
        disabled="true"
        class="primary"
        type="outline"
        onmouseleave="this.setAttribute('type','outline')"
        onmouseenter="this.setAttribute('type','full')">
    </gz-button>
  </gz-card>
`;
